var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.213379,
    y: 0.480347,
    width: 35.4491,
    height: 35.4491,
    rx: 8.60293,
    fill: "#EAF7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9655 14.7662C25.6578 14.2469 26.281 13.6238 26.7656 12.8968C26.1425 13.1737 25.4155 13.3814 24.6885 13.4507C25.4501 13.0006 26.004 12.3083 26.281 11.4428C25.5886 11.8582 24.7924 12.1698 23.9962 12.3429C23.3038 11.6159 22.3691 11.2005 21.3306 11.2005C19.3227 11.2005 17.6956 12.8275 17.6956 14.8354C17.6956 15.1124 17.7303 15.3893 17.7995 15.6662C14.7877 15.4932 12.0875 14.0392 10.2873 11.8582C9.97576 12.3775 9.80267 13.0006 9.80267 13.693C9.80267 14.9393 10.4258 16.047 11.4297 16.7048C10.8412 16.6702 10.2527 16.5317 9.76805 16.2548V16.2894C9.76805 18.0549 11.0143 19.5089 12.676 19.8551C12.399 19.9243 12.0529 19.9935 11.7413 19.9935C11.499 19.9935 11.2913 19.9589 11.0489 19.9243C11.499 21.3783 12.8491 22.4168 14.4415 22.4514C13.1953 23.4207 11.6374 24.0093 9.94114 24.0093C9.62958 24.0093 9.35263 23.9746 9.07568 23.94C10.6681 24.9786 12.5721 25.5671 14.6492 25.5671C21.3306 25.5671 24.9655 20.0628 24.9655 15.2508C24.9655 15.0777 24.9655 14.9393 24.9655 14.7662Z",
    fill: "#1DA1F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4353163391e347fae62952e60ff3c718.svg";
export { ForwardRef as ReactComponent };